import { t, getLang } from './i18n'

// Localized "x ago" relative time, shared across the app (was duplicated and
// hardcoded English in 6 files).
export function timeAgo(date: string): string {
  const s = Math.floor((Date.now() - new Date(date).getTime()) / 1000)
  if (s < 10) return t('justNow')
  if (s < 60) return t('agoSeconds', { n: s })
  if (s < 3600) return t('agoMinutes', { n: Math.floor(s / 60) })
  if (s < 86400) return t('agoHours', { n: Math.floor(s / 3600) })
  return t('agoDays', { n: Math.floor(s / 86400) })
}

// BCP-47 locale for each UI language, so dates format in the chosen language
// (month names, ordering) instead of falling back to the browser locale.
const DATE_LOCALES: Record<string, string> = { en: 'en-US', fr: 'fr-FR', ru: 'ru-RU' }

function dateLocale(): string {
  return DATE_LOCALES[getLang()] ?? 'en-US'
}

// Compact "14 juin, 14:32" timestamp in the user's selected language.
export function formatShortDateTime(date: string): string {
  return new Date(date).toLocaleString(dateLocale(), {
    month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
  })
}

// Full localized date + time, used for hover tooltips and timestamps.
export function formatDateTime(date: string | Date): string {
  return new Date(date).toLocaleString(dateLocale())
}

// Date only (no time), in the user's selected language.
export function formatDate(date: string | Date): string {
  return new Date(date).toLocaleDateString(dateLocale())
}

// Compact "14 juin" date (no year, no time), for chart axes.
export function formatShortDate(date: string | Date): string {
  return new Date(date).toLocaleDateString(dateLocale(), { month: 'short', day: 'numeric' })
}

// Time of day "14:32" (24h), in the user's selected language.
export function formatTime(date: string | Date): string {
  return new Date(date).toLocaleTimeString(dateLocale(), { hour: '2-digit', minute: '2-digit', hour12: false })
}
